const walletTableHead = [
  { id: 'id', width: '11.1' },
  /* { id: 'game', width: '13.1' }, */
  { id: 'operation', width: '14.5' },
  { id: 'amount', width: '20.5' },
  { id: 'notes', width: '31.5' },
  { id: 'timestamp', width: '' },
];

export { walletTableHead };
